import { useState } from 'react';

export default function LegalModal({ show, onClose, initialTab = 'privacy' }) {
  const [tab, setTab] = useState(initialTab);

  if (!show) return null;

  return (
    <div className="blurred-app-state">
      <div className="modal-card legal-modal">
        <button className="sidebar-close-btn" onClick={onClose}>&times;</button>

        <div className="legal-tabs">
          <button
            className={`legal-tab ${tab === 'privacy' ? 'legal-tab-active' : ''}`}
            onClick={() => setTab('privacy')}
          >
            Privacy
          </button>
          <button
            className={`legal-tab ${tab === 'terms' ? 'legal-tab-active' : ''}`}
            onClick={() => setTab('terms')}
          >
            Terms
          </button>
        </div>

        <div className="legal-body">
          {tab === 'privacy' ? <PrivacyContent /> : <TermsContent />}
        </div>

        <button className="btn-bank" style={{ marginTop: 20 }} onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

function PrivacyContent() {
  return (
    <>
      <h2>Privacy Policy</h2>
      <p className="legal-meta">Last updated: April 25, 2026</p>

      <h3>What we collect</h3>
      <ul>
        <li><strong>Profile info</strong> you give us: name, email, optional birthday.</li>
        <li><strong>Game data</strong>: scores, turns, players you play with, optional photos you upload.</li>
        <li><strong>Auth identifier</strong> from Firebase (anonymous or linked to your email/Google account).</li>
        <li><strong>Basic technical data</strong>: device/browser type for debugging.</li>
      </ul>

      <h3>How we use it</h3>
      <ul>
        <li>To run the game (scoring, leaderboards, multiplayer).</li>
        <li>To improve the app and fix bugs.</li>
        <li>To contact you only if you sent us feedback or signed up with an email.</li>
      </ul>

      <h3>Who sees it</h3>
      <p>
        Data is stored in Google Firebase (Firestore + Storage). Other players can see
        your display name, avatar, and game scores. Photos you upload to game results
        or the vault may be visible to anyone with the share link.
      </p>

      <h3>Your choices</h3>
      <ul>
        <li>Play as a guest without an account.</li>
        <li>Email <a href="mailto:joeg@sanalyticsdata.com">joeg@sanalyticsdata.com</a> to delete your account or data.</li>
      </ul>

      <h3>Kids</h3>
      <p>
        Dice Dice Baby is intended for players 13+. We don't knowingly collect data
        from children under 13.
      </p>

      <h3>Contact</h3>
      <p>Questions? <a href="mailto:joeg@sanalyticsdata.com">joeg@sanalyticsdata.com</a></p>
    </>
  );
}

function TermsContent() {
  return (
    <>
      <h2>Terms of Use</h2>
      <p className="legal-meta">Last updated: April 25, 2026</p>

      <p>
        Dice Dice Baby is offered as-is for personal, non-commercial use. By using
        the app, you agree to:
      </p>
      <ul>
        <li>Be respectful — no harassment, hate speech, or illegal content.</li>
        <li>Only upload photos you have rights to share.</li>
        <li>Not abuse the service (spam, scraping, or attempting to break it).</li>
      </ul>

      <p>
        We may update or remove content, accounts, or the app itself at any time.
        The app is provided without warranties; use at your own risk.
      </p>

      <p>
        Promotions, offers, or rewards shown in-app are subject to participating
        venue terms and may be withdrawn or modified.
      </p>

      <p>
        Contact: <a href="mailto:joeg@sanalyticsdata.com">joeg@sanalyticsdata.com</a>
      </p>
    </>
  );
}
